'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const ModalView = require('common/ui/view/modal/index');
const AnnouncementModalView = require('feedback/ui/view/modal/announcement');
const Template = require('feedback/ui/template/admin/announcement/index.hbs');
const AdminCoverView = require('feedback/ui/view/admin/common/cover');
const AnnouncementCreateService = require('feedback/app/service/announcement/create');
const AnnouncementListView = require('feedback/ui/view/admin/announcement/list');
const AnnouncementAdminCollectionFactory = require('feedback/domain/factory/announcement-admin/collection');

const AnnouncementView = Mn.View.extend({
    tagName: 'div',
    className: 'announcement-list',
    template: Template,
    regions: {
        announcementList: '.announcement-list-wrapper',
        cover: '#cover',
    },
    ui: {
        announcementCreateButton: '.announcement-create-button'
    },
    events: {
        'click @ui.announcementCreateButton': 'createAnnouncement'
    },

    onRender: function() {
        this.showChildView('cover', new AdminCoverView({isAnnouncement: true}));

        const collection = AnnouncementAdminCollectionFactory.getCollection();

        collection
            .fetchFirstPage()
            .then(() => {
                this.showChildView('announcementList', new AnnouncementListView({
                    collection: collection
                }));
            });
    },

    createAnnouncement: function() {
        const modal = new ModalView({
            title: i18n.t('feedback_template:announcement.manage.modal.create.title'),
            bodyView: new AnnouncementModalView({
            }),
            large: true,
            onChildviewSave: function() {
                const announcementJSON = this.getChildView('body').getAttributes();
                this.disableButtons();

                const service = new AnnouncementCreateService(announcementJSON);
                service.create()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    }
});

module.exports = AnnouncementView;



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/announcement/index.js